import React from "react";
import "./page404.scss";
import { Link } from "react-router-dom";

export default function Page404() {
  return (
    <div className="not_found">
      <h1>
        404 Not Found<span>ページが見つかりませんでした。</span>
      </h1>
      <Link to="/">生地一覧に戻る</Link>
    </div>
  );
}
